export default __webpack_public_path__ + "assets/garage.86d38bb0.svg";